import { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar";
import "../document/document.css";
import { FaDownload, FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { screenPath } from "../../constant/strings";
import { getDocumentsListApi } from "../../services/apiCall";
import { useSelector } from "react-redux";

export default function DocumentPage() {
  const navigation = useNavigate();
  const businessId = useSelector((state) => state?.user?.businessId);

  const [activeTab, setActiveTab] = useState("expense_receipt");
  const [documents, setDocuments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const tabs = [
    { id: "expense_receipt", label: "Expense" },
    { id: "sales_invoice", label: "Sales" },
    { id: "mileage_receipt", label: "Mileage" },
    { id: "bank_statement", label: "Bank" },
    { id: "misc", label: "Misc" },
  ];

  const handleViewDocs = (doc) => {
    navigation(screenPath.documentViewerPage, { state: { document: doc } });
  };

  const handleDownload = (doc) => {
    const url = doc.downloadUrl || doc.url;
    if (url) {
      window.open(url, "_blank");
    } else {
      alert("Download URL not available");
    }
  };
  const fetchDocuments = async () => {
    if (!businessId) return;
    setIsLoading(true);
    try {
      const payload = {
        businessId,
        documentType: activeTab,
        status: "processed",
        limit: 25,
        includeDownloadUrl: true,
        downloadExpiry: 900,
      };
      const res = await getDocumentsListApi(payload);
      console.log("response from fetchDocuments", res);

      const data = res?.data;
      const docs =
        data?.data ||
        data?.documents ||
        data?.items ||
        (Array.isArray(data) ? data : []);
      if (Array.isArray(docs)) {
        setDocuments(docs);
      } else {
        setDocuments([]);
      }
    } catch (error) {
      console.log("catch error from fetchDocuments", error);
      setDocuments([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, [businessId, activeTab]);

  return (
    <div className="app">
      <Sidebar />
      <main className="main">
        <div>
          <h1>Documents</h1>
          <p>All Documents uploaded by your clients.</p>
        </div>

        <div className="clients-card">
          <div className="tabs-container">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={`tab-button ${activeTab === tab.id ? "active" : ""}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <h3 className="clients-title">
            {tabs.find((t) => t.id === activeTab)?.label} Documents
          </h3>
          <p className="clients-subtitle">View and manage specific documents</p>

          {isLoading ? (
            <p>Loading documents...</p>
          ) : documents.length === 0 ? (
            <p>No documents found.</p>
          ) : (
            <table className="clients-table">
              <thead>
                <tr>
                  <th>File Name</th>
                  <th>Type</th>
                  <th>Status</th>
                  <th>Uploaded</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {documents.map((doc, index) => (
                  <tr key={doc.id || index}>
                    <td className="name">
                      {doc.fileName ||
                        doc.documentName ||
                        doc.originalFileName ||
                        `Document ${index + 1}`}
                    </td>
                    <td>{doc.documentType || doc.type || activeTab}</td>
                    <td>
                      <span
                        className={`status-badge ${
                          (doc.status || "processed")
                            .toLowerCase()
                            .includes("process") || doc.status === "Active"
                            ? "active"
                            : "pending"
                        }`}
                      >
                        {doc.status || "Processed"}
                      </span>
                    </td>
                    <td>
                      {doc.createdAt
                        ? new Date(doc.createdAt).toLocaleDateString()
                        : doc.uploaded || "N/A"}
                    </td>
                    <td className="actions">
                      <FaEye
                        size={17}
                        color="#000"
                        onClick={() => handleViewDocs(doc)}
                      />
                      <div style={{ width: 5 }}></div>
                      <FaDownload
                        size={17}
                        color="#000"
                        onClick={() => handleDownload(doc)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </main>
    </div>
  );
}
